import React, { Fragment } from 'react';
import { Input, ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import FormErrors from 'components/formErrors/FormErrors';
import { isValueEntered, isNumberValid, is0to100NumberValid } from 'services/Validation';

export const inputFields = (data, handleUserInput) => {
    return (
        <Fragment>
            <div className="col-lg-9 d-flex flex-column order-lg-1">
                <h3 className="card-heading">{<IntlMessages id="label.name" />}</h3>
                <Input id="name" type="text" className={`form-control mb-2 ${data?.name ? 'is-valid' : 'is-invalid'}`}
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.name} name="name"
                />
                <h3 className="card-heading">{<IntlMessages id="label.description" />}</h3>
                <Input id="description" type="text" className="form-control mb-2"
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.description} name="description"
                />
                <h3 className="card-heading">{<IntlMessages id="label.role" />}</h3>
                <Input id="role" type="text" className="form-control mb-2"
                    onChange={(event) => handleUserInput(event)}
                    defaultValue={data?.role} name="role"
                />
                <h3 className="card-heading">{<IntlMessages id="label.rate" />}</h3>
                <Input id="rate" type="text" className="form-control mb-2"
                    onChange={(event) => handleUserInput(event, true)}
                    defaultValue={data?.rate} name="rate"
                />
                <h3 className="card-heading">{<IntlMessages id="label.allocation" />}</h3>
                <Input id="allocation" type="text" className="form-control mb-2"
                    onChange={(event) => handleUserInput(event, true)}
                    defaultValue={data?.allocation} name="allocation"
                />
            </div>
        </Fragment>
    );
};

export const displayedImage = (selectedMember) => {
    return (
        <div className="col-lg-3 text-center text-lg-right order-lg-2">
            <img id="thumb" className="ml-lg-3 mb-4 mb-lg-0 avatar size-120" src={selectedMember?.thumb || 'assets/images/members-1_225_225.jpg'} />
        </div>
    );
};

export const showErrors = (formErrors) => {
    if (formErrors) {
        return (
            <div className="panel panel-default">
                <FormErrors formErrors={formErrors} />
            </div>
        );
    }
    return null;
};

export const modalHeader = (title, modalHeaderOnClick) => {
    return (
        <ModalHeader className="modal-box-header bg-primary">
            {title}
            <span className="text-white pointer">
                <i className="zmdi zmdi-close zmdi-hc-lg" onClick={modalHeaderOnClick()} />
            </span>
        </ModalHeader>
    );
};

export const isFormValid = (selectedMember) => {
    return isValueEntered(selectedMember?.name);
};

export const getFormError = (fieldName, value) => {
    let formError = '';
    switch (fieldName) {
        case 'name':
        case 'role':
            formError = isValueEntered(value) ? '' : ' is invalid';
            break;
        case 'rate':
            formError = isNumberValid(value) ? '' : ' is invalid. It must be a number';
            break;
        case 'allocation':
            formError = is0to100NumberValid(value) ? '' : ' is invalid. It must be a number from 0 to 100';
            break;
        default:
            break;
    }
    return formError;
};


// WEBPACK FOOTER //
// ./components/Agile/member/memberMaintenance/common.js